// extracted by mini-css-extract-plugin
module.exports = {"main":"index_main__d1O6_"};